module.exports = __webpack_public_path__ + "img/UPS.png";